/**
 * Labstep
 *
 * @module components/UserGroup/List
 * @desc A multilist listing user groups
 */

import { UserGroupCardPreview as UserGroupCard } from 'labstep-web/components/UserGroup/Card/Preview';
import { List } from 'labstep-web/core/List';
import type React from 'react';
import type { IUserGroupListProps } from './types';

export const UserGroupList: React.FC<IUserGroupListProps> = ({
  userGroups,
}) => (
  <List id="group-list">
    {userGroups.map((userGroup) => (
      <div key={userGroup.id}>
        <UserGroupCard userGroup={userGroup} />
      </div>
    ))}
  </List>
);
